import { render, staticRenderFns } from "./FormImportItems.vue?vue&type=template&id=45d14356&scoped=true"
import script from "./FormImportItems.vue?vue&type=script&lang=js"
export * from "./FormImportItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d14356",
  null
  
)

export default component.exports